export const UPDATE_FORMULA = 'app/Dashboard/SessionSettings/UPDATE_FORMULA';

export const ADD_FORMULA_CASE =
  'app/Dashboard/SessionSettings/ADD_FORMULA_CASE';

export const REMOVE_FORMULA_CASE =
  'app/Dashboard/SessionSettings/REMOVE_FORMULA_CASE';

export const UPDATE_FORMULA_CASE =
  'app/Dashboard/SessionSettings/UPDATE_FORMULA_CASE';

export const CHANGE_FORMULA_STATUS =
  'app/Dashboard/SessionSettings/CHANGE_FORMULA_STATUS';

export const CHANGE_SCHEDULING_TYPE =
  'app/Dashboard/SessionSettings/CHANGE_SCHEDULING_TYPE';

export const UPDATE_SCHEDULING_PAYLOAD =
  'app/Dashboard/SessionSettings/UPDATE_SCHEDULING_PAYLOAD';

export const UPDATE_SCHEDULING_DATE =
  'app/Dashboard/SessionSettings/UPDATE_SCHEDULING_DATE';

export const UPDATE_DAYS_AFTER_DATE_VARIABLE =
  'app/Dashboard/SessionSettings/UPDATE_DAYS_AFTER_DATE_VARIABLE';

export const ADD_FORMULA_TARGET =
  'app/Dashboard/SessionSettings/ADD_FORMULA_TARGET';

export const UPDATE_FORMULA_TARGET =
  'app/Dashboard/SessionSettings/UPDATE_FORMULA_TARGET';

export const REMOVE_FORMULA_TARGET =
  'app/Dashboard/SessionSettings/REMOVE_FORMULA_TARGET';

export const ADD_NEW_FORMULA = 'app/Dashboard/SessionSettings/ADD_NEW_FORMULA';

export const REMOVE_FORMULA = 'app/Dashboard/SessionSettings/REMOVE_FORMULA';

export const DUPLICATE_FORMULA =
  'app/Dashboard/SessionSettings/DUPLICATE_FORMULA';
